import React from 'react';
import PropTypes from 'prop-types'

import { Toolbar as MuiToolbar, ToolbarGroup } from 'material-ui/Toolbar';
import { SaveButton } from '../button';


const Toolbar = (props) => {
  const { children } = props;
  return (
    <MuiToolbar>
      <ToolbarGroup>
        {children}
      </ToolbarGroup>
    </MuiToolbar>
  );
};

Toolbar.propTypes = {
  children: PropTypes.node,
};

Toolbar.defaultProps = {
  children: <SaveButton/>,
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/form/Toolbar.js